<template>
    <v-row no-gutters class="eventRaceImages">
      <v-col class="pa-3">
        <RaceAdvanceSetting />
      </v-col>
    </v-row>
</template>

<script>
import RaceAdvanceSetting from "@/components/dashboard/eventDetails/raceList/RaceAdvanceSetting.vue";

export default {
    components: {
        RaceAdvanceSetting
    },
}
</script>